import {
  FetchAllProceduresCommand,
  ProcedureDto
} from '@/Application/Procedures'
import {
  ProcedureRepository
} from '@/Domain/Procedures'
import { PaginatedResultDto } from '@/Application/Pagination/PaginatedResultDto'

export class FetchAllProceduresCommandHandler {
  private procedureRepository: ProcedureRepository

  constructor (
    procedureRepository: ProcedureRepository
  ) {
    this.procedureRepository = procedureRepository
  }

  async handle (command: FetchAllProceduresCommand): Promise<PaginatedResultDto<ProcedureDto>> {
    const currentPage = command.page()
    const itemsPerPage = command.itemsPerPage()
    const pagination = { page: currentPage, itemsPerPage }
    const procedures = await this.procedureRepository.findAll(pagination, command.filters(), command.ordering())
    const totalItems = await this.procedureRepository.totalItemsCount(command.filters())
    const response: ProcedureDto[] = []
    for (const procedure of procedures) {
      response.push(ProcedureDto.fromProcedure(procedure))
    }
    const pages = totalItems === 0 ? 0 : Math.ceil(totalItems / itemsPerPage)
    return new PaginatedResultDto(totalItems, pages === 0 ? 0 : currentPage, pages, response)
  }
}
